// auth.js

// state
const state = {
  user: null,
  admin: null
}

// getters
const getters = {
  user: (state) => state.user,
  isAuth: (state) => !!state.user,
  adminHasAccess: (state) => (roles) => state.admin && state.admin.userRoles.some(role => roles.includes(role)),
  isAuthAlphaTester: (state) => state.user && state.user.is_alpha_tester,
  isAuthBetaTester: (state) => state.user && state.user.is_beta_tester
}

// mutations
const mutations = {
  setUser(state, user) {
    state.user = user
  },
  setAdmin(state, admin) {
    state.admin = admin
  }
}

// actions
const actions = {
  setAuthUser({ commit }, user = null) {
    commit('setUser', user)
  },
  setAuthAdmin({ commit }, admin = null) {
    commit('setAdmin', admin)
  }
}

// Экспорт по умолчанию
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
